import { useContext } from 'react';

import { AppLayoutContext } from '../AppLayoutContextProvider';
import type { AppLayoutContextValue } from '../AppLayoutContextProvider.types';

export const useAppLayoutContext = (): AppLayoutContextValue | undefined => useContext(AppLayoutContext);

type UseAppLayoutWidth = () => number;
export const useAppLayoutWidth: UseAppLayoutWidth = () => useAppLayoutContext()?.width ?? Infinity;

type UseAppLayoutGutterSize = () => number;
export const useAppLayoutGutterSize: UseAppLayoutGutterSize = () => useAppLayoutContext()?.gutterSize ?? 0;
